// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.block-component__view {
  display: inline-flex;
  align-items: stretch;
  justify-content: flex-start;
  background: var(--white-color);
  border-radius: 8px;
}

.block-component__view-text {
  align-content: center;
  color: var(--web-primary-color);
}

.block-component__marker {
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 800;
  background-color: var(--background-color-3);
  border-radius: 40px;
}
.block-component__marker .marker {
  color: var(--accent-color);
}

@media only screen and (min-device-width: 320px) {
  .block-component__view {
    gap: 8px;
  }
  .block-component__marker {
    width: 40px;
    height: 40px;
  }
  .center {
    gap: 20px;
    flex-direction: column;
    align-items: flex-start;
    padding: 16px;
  }
}
@media only screen and (min-device-width: 768px) {
  .block-component__view {
    flex-direction: row;
    gap: 20px;
  }
  .block-component__marker {
    width: 56px;
    height: 56px;
  }
  .center {
    gap: 32px;
    align-items: center;
    padding: 24px 36px;
  }
}
@media only screen and (min-device-width: 992px) {
  .block-component__view {
    flex-direction: row;
    gap: 28px;
  }
  .center {
    gap: 52px;
    align-items: center;
    padding: 28px;
  }
  .block-component__marker {
    width: 64px;
    height: 64px;
  }
}
@media only screen and (min-device-width: 1366px) {
  .block-component__view {
    flex-direction: row;
    gap: 28px;
  }
  .center {
    gap: 52px;
    align-items: center;
    padding: 36px;
  }
  .block-component__marker {
    width: 64px;
    height: 64px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/BlockComponent/blockComponent.scss"],"names":[],"mappings":"AAAA;EACE,oBAAA;EACA,oBAAA;EACA,2BAAA;EACA,8BAAA;EACA,kBAAA;AACF;;AAEA;EACE,qBAAA;EACA,+BAAA;AACF;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,2CAAA;EACA,mBAAA;AACF;AAAE;EACG,0BAAA;AAEL;;AAEA;EACE;IACE,QAAA;EACF;EAGA;IACE,WAAA;IACA,YAAA;EADF;EAGA;IACE,SAAA;IACA,sBAAA;IACA,uBAAA;IACA,aAAA;EADF;AACF;AAIA;EACE;IACE,mBAAA;IACA,SAAA;EAFF;EAKA;IACE,WAAA;IACA,YAAA;EAHF;EAKA;IACE,SAAA;IACA,mBAAA;IACA,kBAAA;EAHF;AACF;AAMA;EACE;IACE,mBAAA;IACA,SAAA;EAJF;EAOA;IACE,SAAA;IACA,mBAAA;IACA,aAAA;EALF;EAOA;IACE,WAAA;IACA,YAAA;EALF;AACF;AAQA;EACE;IACE,mBAAA;IACA,SAAA;EANF;EASA;IACE,SAAA;IACA,mBAAA;IACA,aAAA;EAPF;EASA;IACE,WAAA;IACA,YAAA;EAPF;AACF","sourcesContent":[".block-component__view {\n  display: inline-flex;\n  align-items: stretch;\n  justify-content: flex-start;\n  background: var(--white-color);\n  border-radius: 8px;\n}\n\n.block-component__view-text {\n  align-content: center;\n  color: var(--web-primary-color);\n}\n\n.block-component__marker {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-weight: 800;\n  background-color: var(--background-color-3);\n  border-radius: 40px;\n  .marker{\n     color: var(--accent-color);\n  }\n}\n\n@media only screen and (min-device-width: 320px) {\n  .block-component__view {\n    gap: 8px;\n    //flex-direction: column;\n    //padding: 16px;\n  }\n  .block-component__marker {\n    width: 40px;\n    height: 40px;\n  }\n  .center{\n    gap: 20px;\n    flex-direction: column;\n    align-items: flex-start;\n    padding: 16px;\n  }\n}\n\n@media only screen and (min-device-width: 768px) {\n  .block-component__view {\n    flex-direction: row;\n    gap: 20px;\n    //padding: 24px 36px;\n  }\n  .block-component__marker {\n    width: 56px;\n    height: 56px;\n  }\n  .center{\n    gap: 32px;\n    align-items: center;\n    padding: 24px 36px;\n  }\n}\n\n@media only screen and (min-device-width: 992px) {\n  .block-component__view {\n    flex-direction: row;\n    gap: 28px;\n    //padding: 28px;\n  }\n  .center{\n    gap: 52px;\n    align-items: center;\n    padding: 28px;\n  }\n  .block-component__marker {\n    width: 64px;\n    height: 64px;\n  }\n}\n\n@media only screen and (min-device-width: 1366px) {\n  .block-component__view {\n    flex-direction: row;\n    gap: 28px;\n    //padding: 36px;\n  }\n  .center{\n    gap: 52px;\n    align-items: center;\n    padding: 36px;\n  }\n  .block-component__marker {\n    width: 64px;\n    height: 64px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
